import { BASE_API_URL } from "@src/shared/api/api";

export const API = {
  GET_REQUEST_RESULTS: (request_uuid: string) =>
    `${BASE_API_URL}/matching/cold_matching/results/${request_uuid}`,
};
